import React from 'react'
import { Locations } from 'EstraSuppliers'
import { useFormikContext } from 'formik'
import { ProfileFormValues } from '../../utils'
import { useLocationFields } from '../useLocationFields'
import { FormGrid } from 'app/components/shared/FormGrid'
import { SmartInput } from 'app/components/formik/Input'

interface Props {
  locations: Locations
}
export const Contacts: React.FC<Props> = ({ locations }) => {
  const { values, setFieldValue } = useFormikContext<ProfileFormValues>()
  const { provinceOptions, cityOptions } = useLocationFields(
    locations,
    values.company_province_id
  )

  return (
    <>
      <FormGrid cols={[8, 2, 2]}>
        <SmartInput
          label='Indirizzo sede legale'
          name='company_address_street'
          required
        />
        <SmartInput label='Civico' name='company_address_number' required />

        <SmartInput label='CAP' name='company_postal_code' required />
      </FormGrid>

      <FormGrid cols={[6, 6]}>
        <SmartInput
          type='select'
          label='Provincia'
          name='company_province_id'
          required
          selectCaretSize='small'
          // reset company city when company province changes
          onChange={() => setFieldValue('company_city_id', '')}
        >
          <option value={''}>Seleziona</option>
          {provinceOptions.map(province => (
            <option key={province.value} value={province.value}>
              {province.label}
            </option>
          ))}
        </SmartInput>

        <SmartInput
          type='select'
          label='Comune'
          name='company_city_id'
          required
          selectCaretSize='small'
          disabled={!cityOptions.length}
        >
          <option value={''}>Seleziona</option>
          {cityOptions.map(city => (
            <option key={city.value} value={city.value}>
              {city.label}
            </option>
          ))}
        </SmartInput>
      </FormGrid>

      <FormGrid cols={[6, 6]}>
        <SmartInput textPrefix='+39' label='Telefono' name='phone' required />

        <SmartInput
          textPrefix='+39'
          label='Cellulare'
          name='company_mobile_number'
          required
        />
      </FormGrid>

      <FormGrid cols={[6, 6]}>
        <SmartInput textPrefix='+39' label='Fax' name='company_fax_number' />
      </FormGrid>

      <FormGrid cols={[6, 6]}>
        <SmartInput type='email' label='PEC' name='company_pec' required />

        <SmartInput
          type='email'
          label='Email di contatto'
          name='email'
          required
        />
      </FormGrid>
    </>
  )
}
